<template>
<svg viewBox="0 0 48 48" :fill="useCurrentColor ? 'currentColor' : '#000'" :class="[`${prefix}-icon`, `${prefix}-icon-alarm`]" width="1em" height="1em" v-bind="$attrs"><path fill-rule="evenodd" clip-rule="evenodd" d="M39.794 8.5l-6.928-4a1 1 0 00-1.366.366l-1 1.732a1 1 0 00.366 1.366l6.928 4a1 1 0 001.366-.366l1-1.732a1 1 0 00-.366-1.366zm-25-3a1 1 0 011.366.366l1 1.732a1 1 0 01-.366 1.366l-6.928 4a1 1 0 01-1.366-.366l-1-1.732A1 1 0 017.866 9.5l6.928-4zm9.536 4.732c9.389 0 17 7.611 17 17s-7.611 17-17 17-17-7.611-17-17 7.611-17 17-17zm0 4c-7.18 0-13 5.82-13 13s5.82 13 13 13 13-5.82 13-13-5.82-13-13-13zm1.993 4.883a1 1 0 00-.993-.883h-2l-.116.007a1 1 0 00-.884.993v8.845l5.515 6.704.086.092a1 1 0 001.322.045l1.544-1.271.092-.086a1 1 0 00.045-1.322l-4.604-5.596v-7.411l-.007-.117z"/></svg>
</template>
<script>

export default {
  name: 'IconAlarm',
  props: {
    prefix: {
        type: String,
        default: 'arco',
    },
    useCurrentColor: {
        type: Boolean,
        default: true,
    },
  },
};
</script>
